import { observable } from 'mobx'

export default class userBodyWeightStore {
  @observable bodyWeightData = []
  @observable sessionData = []
  @observable created = false

  updateBodyWeightData(data) {
    this.bodyWeightData = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updateCreated() {
    this.created = true
  }

  updateDataBySession() {
    var index = this.bodyWeightData
      .map(x => {
        return x.id
      })
      .indexOf(this.sessionData.id)
    this.bodyWeightData[index] = this.sessionData
  }
}



// WEBPACK FOOTER //
// ./src/stores/userBodyWeightStore.js